/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-08-03 10:36:01
 * @modify date 2021-08-03 10:36:49
 * @desc [description]
 */

exports.EmbedContext = require('react').createContext({});
